﻿var activeiconTemplate = require('../templates/searchbox-activeicon.handlebars');

class SearchBox {

    constructor() {
        this.$elm = $('.searchBox');
        this.$icon = $('.iconmenu-item--search');
        this.$header = $('.header');
        this.$input = this.$elm.find('.inputField');
        this.$submit = this.$elm.find('.searchBox-submit');
        this.$form = this.$elm.find('form');
        this.activeClass = 'searchBox--isOpen';
        this.iconActiveClass = 'iconmenu-item--search--active';
        this.headerActiveClass = 'header--searchBoxIsOpen';

        this.submitClicked = false;

        if (this.$icon[0] !== null && typeof this.$icon[0] !== "undefined") {
            this.iconHtml = this.$icon[0].innerHTML;
            this.iconText = this.$header[0].dataset.closeText;

            this.setEventListeners();
        }
    }

    setEventListeners() {
        this.$icon
            .on('click', this.onMenuIconClick.bind(this));
        this.$input
            .on('blur', this.onInputBlur.bind(this));
        this.$submit
            .on('click', this.onSubmitClick.bind(this));
    }

    toggle() {
        if (this.$icon.hasClass(this.iconActiveClass)) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.$icon.addClass(this.iconActiveClass);
        this.$elm.addClass(this.activeClass);
        this.$header.addClass(this.headerActiveClass);
        this.$input.focus();

        this.$icon.html(activeiconTemplate({
            iconText: this.iconText
        }));
    }

    close() {
        this.$icon.removeClass(this.iconActiveClass);
        this.$elm.removeClass(this.activeClass);
        this.$header.removeClass(this.headerActiveClass);

        this.$icon.html(this.iconHtml);
    }

    onMenuIconClick(event) {
        event.preventDefault();

        this.toggle();
    }

    onInputBlur(event) {
        //timeout to be able to check for submit clicked state
        setTimeout(() => {
            if (!this.submitClicked) {
                this.close();
            }
        }, 200);
    }

    onSubmitClick(event) {
        event.preventDefault();

        this.submitClicked = true;
        this.$form.submit();
    }
}

export default SearchBox;